import styled from '@emotion/styled';
import { WarningOutlined } from '@ant-design/icons';

export const WarningIcon = styled(WarningOutlined)`
  color: var(--surface-error-action);
`;
